<template>
  <Teleport to="body">
    <div class="fixed top-5 right-5 z-[9999] flex flex-col gap-2 items-end">
      <transition-group name="undo-toast-fade">
        <div
          v-for="entry in entries"
          :key="entry.id"
          role="status"
          aria-live="polite"
          class="bg-white border border-gray-200 border-l-[3px] border-l-blue-500 rounded-md shadow-lg px-5 py-3.5 font-['IBM_Plex_Sans'] text-sm text-gray-700 flex items-center gap-4 min-w-[220px]"
          :class="{ '!border-l-green-500': entry.undone, '!border-l-red-500': entry.error }"
        >
          <span class="grow">
            {{ entry.error ? `Save failed: ${entry.message}` : entry.undone ? 'Change undone' : entry.message }}
          </span>
          <span v-if="entry.committing" class="text-[10px] text-gray-400">Saving…</span>
          <button
            v-else-if="entry.error"
            class="font-semibold text-red-500 hover:text-red-700 tracking-wide shrink-0"
            @click="retry(entry.id)"
          >
            RETRY
          </button>
          <button
            v-else-if="!entry.settled"
            class="font-semibold text-blue-500 hover:text-blue-700 tracking-wide shrink-0"
            @click="undo(entry.id)"
          >
            UNDO
          </button>
          <button
            class="text-gray-400 hover:text-gray-600 shrink-0 w-4 h-4 flex items-center justify-center"
            aria-label="Dismiss"
            @click="dismiss(entry.id)"
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
              <line x1="1" y1="1" x2="9" y2="9" />
              <line x1="9" y1="1" x2="1" y2="9" />
            </svg>
          </button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<script>
import undoQueue, { undoState } from './supportUndo';

export default {
  name: 'Support_UndoToast',
  computed: {
    entries() {
      return undoState.entries;
    },
  },
  methods: {
    show(message, commitFn, undoFn) {
      return undoQueue.show(message, commitFn, undoFn);
    },
    undo(id) {
      undoQueue.undo(id);
    },
    retry(id) {
      undoQueue.retry(id);
    },
    dismiss(id) {
      undoQueue.dismiss(id);
    },
  },
};
</script>

<style scoped>
.undo-toast-fade-enter-active,
.undo-toast-fade-leave-active {
  transition: opacity 0.25s ease;
}
.undo-toast-fade-enter-from,
.undo-toast-fade-leave-to {
  opacity: 0;
}
</style>
